import { Pin } from "lucide-react";
import { fmtDate } from "@/lib/api";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const AnnouncementCard = ({ a, compact }) => (
  <article id={`ann-${a.id}`} className="rounded-3xl border border-border bg-card overflow-hidden scroll-mt-24" data-testid={`announcement-${a.id}`}>
    {a.image_url && <img src={`${BASE}${a.image_url}`} alt="" className={compact ? "w-full h-44 object-cover" : "w-full max-h-[420px] object-cover"} />}
    <div className="p-6">
      <div className="flex flex-wrap items-center gap-2 text-xs font-bold text-muted-foreground">
        {a.pinned && <span className="inline-flex items-center gap-1 rounded-full bg-amber-400 text-[#0A1F13] px-2 py-0.5"><Pin className="h-3 w-3" />Pinned</span>}
        {a.visibility === "members" && <span className="rounded-full bg-purple-500/15 text-purple-500 px-2 py-0.5">Members only</span>}
        <span>{fmtDate(a.publish_at)}</span>
      </div>
      <h3 className="mt-3 font-display text-xl sm:text-2xl font-bold">{a.title}</h3>
      <div className={`rich-content mt-3 text-muted-foreground ${compact ? "line-clamp-4" : ""}`} dangerouslySetInnerHTML={{ __html: a.body }} />
    </div>
  </article>
);

export const AnnouncementList = ({ items, compact, empty = "No announcements yet." }) => (
  <div className={compact ? "grid gap-6 md:grid-cols-3" : "space-y-6"} data-testid="announcement-list">
    {items.length === 0 && <p className="text-muted-foreground" data-testid="announcements-empty">{empty}</p>}
    {items.map((a) => <AnnouncementCard key={a.id} a={a} compact={compact} />)}
  </div>
);
